import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
  input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '@env/environment.local';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import {
  FinancialProductEnum,
  financialResponseDto,
  models,
  quoteDto,
  residualValue,
  warrantyType,
} from '../../model/standard-quote.model';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { TaxType, packageAppliesToQuoteCompany } from '../../../open-quote/model/open-quote.model';
import { FinancialCalculatorService } from '../../../open-quote/financial-calculator.service';
import { ModalService } from '@app/components/modal/modal.service';
import { OpenQuoteService } from '@app/pages/quote/open-quote/open-quote-service.service';
import { StandardFinancialSetupAttribute } from '@app/pages/quote/standard-quote/model/financial-setup.model';
import { InsuranceService, InsuranceTypeEnum } from '@app/services/insurance.service';
import { finalize } from 'rxjs';

@Component({
  template: ''
})
export class FinancialProductWrapperComponent
  extends BaseComponent
  implements OnInit, ControlValueAccessor, Validator {
  readonly insuranceService = inject(InsuranceService);
  private readonly financialCalculator = inject(FinancialCalculatorService);
  public readonly quoteService = inject(StandardQuoteService);
  public readonly _openQuoteService = inject(OpenQuoteService);
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(ActivatedRoute);
  private readonly modalService = inject(ModalService);

  models: models | undefined = this.quoteService.formData?.model;
  financialService: quoteDto | null = this.quoteService.formData;

  @Input() reset: boolean;
  @Input() grace: any[];
  @Input() specialPayments: any[];
  @Input() insurance: any;
  @Input() financialCondition: any | null;


  @Output() calculate: EventEmitter<any> = new EventEmitter<any>();
  @Output() financialConditionEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() _deleteAllPayments: EventEmitter<any> = new EventEmitter<any>();
  @Output() requestDownloadJson: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletePayments: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;

  formFinance: FormGroup;

  financialPackages: financialResponseDto[] = [];
  paymentTerms: any[] = [];
  _financialPackageOptions: any[] = [];
  _financialProduct: any;
  /** Valor pendiente al editar deal con grace/specialPayments/insurance: solo se aplica si el usuario confirma en el modal. */
  _pendingFinancialValue: any = null;

  /** Evita reentrar a valueChanges mientras selectedResidual u otros emiten (recursión infinita). */
  private _suppressFinancialFormValueChanges = false;

  private readonly _sensitiveFinanceFieldNames = [
    'financialProduct',
    'id',
    'termId',
    'downPaymentTax',
    'downPayment',
    'openingFeeTax',
    'openingFee',
    'balloon',
    'balloonType',
    'balloonPercentage',
    'taxFree',
  ] as const;

  taxType = TaxType;
  isLoading: boolean = false;
  minDownPaymentPercentage: any;
  maxDownPaymentPercentage: any;
  minDownPaymentPrice: number;
  maxDownPaymentPrice: number;
  idQuote: any;
  idDeal: any;
  change: number = 0;
  price: number;
  packageDescription: string = '';
  packageVersion: string = '';
  residualValues: residualValue[] = [];
  residualValueSelected: residualValue | null;
  warrantyType: warrantyType | null;
  productList = this.quoteService.financialProductsList;
  downPaymentTaxType: string;
  protected readonly taxFreeOptions = [
    {
      value: true,
      display: 'SI',
    },
    {
      value: false,
      display: 'NO',
    }
  ];
  readonly payments = input<any[]>([], {
  });

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
    this.createForm();
    this.residualValues = this.quoteService.residualValue;
  }


  ngOnInit() {
    this.price = this.getPrice();

    if (this.financialCondition)
      this.formFinance.controls['termId'].setValue(this.financialCondition.id);

    this.getFinancialPackage();
    this.nominalRateControl.disable();
    this.router.paramMap.subscribe((params) => {
      this.idQuote = params.get('id');
      this.idDeal = params.get('idDeal');
      if (!this.idDeal && !this.quoteService.duplicateDeal) {
        this.change = 1;
      }
    });

    this.quoteService.customerLoyaltyFeriaChanged
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => this.onCustomerLoyaltyFeriaFlagsChanged());

    this.productList = this.productList.filter((product) => {
      if (this.financialService?.companyName === 'SOFOM') {
        return product.value !== FinancialProductEnum.pureLease;
      }
      return true;
    });

    // interval(20000).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(()=>{
    //   console.log("Validando FORM");
    //   console.log("warrantyType", this.warrantyType);
    //   console.log("isWarrantyExternal", this.isWarrantyExternal);
    //   console.log("residualValues", this.residualValues);
    //   console.log("residualValueSelected", this.residualValueSelected);
    //   console.log("form errors", this.formFinance.errors);
    //   console.log("form status", this.formFinance.status);
    //   console.log("form valid", this.formFinance.valid);
    //   console.log("getRawValue", this.formFinance.getRawValue());
    //   for (const key in this.formFinance.controls) {
    //     const control = this.formFinance.controls[key];
    //     if (control.invalid) {
    //       console.log(`El campo ${key} tiene el siguiente error:`, control.errors);
    //     }
    //   }
    //   console.log("FIN validacion")
    // });
    //this.quoteService.formData.
  }

  getPrice() {
    let price = 0;
    if (this.financialService?.standardQuoteModel?.price) {
      return this.financialService.standardQuoteModel.price;
    }
    if (this.financialService?.model) {
      price = this.financialService.model.price;
      if (this.financialService.accessories) {
        this.financialService.accessories.map((i) => (price += i.price));
      }
    }
    return price;
  }

  createForm() {
    this.formFinance = this.fb.group({
      financialProduct: [, [Validators.required]],
      id: [, [Validators.required]],
      termId: [, [Validators.required]],
      financialCondition: [, [Validators.required]],
      nominalRate: [, [Validators.required]],
      downPaymentTaxType: [, [Validators.required]],
      downPayment: [, []],
      downPaymentTax: [, [Validators.required]],
      paymentType: [, [Validators.required]],
      balloon: [, []],
      balloonType: [, []],
      balloonPercentage: [, []],
      openingFee: [, []],
      openingFeeType: [, [Validators.required]],
      openingFeeTax: [, [Validators.required]],
      calendarType: [, [Validators.required]],
      calculationType: [, [Validators.required]],
      daimlerRate: [],
      externalsMinRate: [],
      externalsMaxRate: [],
      externalWarrantyRate: [],
      term: [],
      taxFree: [false, [Validators.required]],
    });

    this.formFinance.valueChanges.subscribe((value) => {
      if (this._suppressFinancialFormValueChanges) {
        return;
      }

      const isSensitiveEdit =
        this.idDeal &&
        (this.grace.length > 0 ||
          this.specialPayments.length > 0 ||
          this.insurance);
      const dirtySensitiveField = isSensitiveEdit
        ? this._sensitiveFinanceFieldNames.find((name) =>
            this.formFinance.get(name)?.dirty
          )
        : null;

      if (dirtySensitiveField) {
        if (
          dirtySensitiveField === 'termId' &&
          !this.shouldOpenSensitiveModalForTermChangeBecauseOfInsurance()
        ) {
          const termId = this.termIdControl.value;
          const termRow = this.paymentTerms?.find((i) => i.id == termId);
          if (termRow) {
            this.financialConditionEmit.emit(termRow);
          }
          this.onChange(value);
          this._financialProduct = { ...this.formFinance.getRawValue() };
          this.onTouched();
          return;
        }
        // No propagar ni borrar nada hasta que el usuario confirme: revertir y mostrar modal.
        this._pendingFinancialValue = this.formFinance.getRawValue();
        this.formFinance.patchValue(this._financialProduct, {
          emitEvent: false,
        });
        this.markSensitiveFinanceControlsPristine();
        this.runWithoutFinancialFormValueChanges(() =>
          this.refreshAuxiliaryFinancialStateAfterRevert()
        );
        this.modalService.component = this.modalTemplate;
        this.modalService.openModal();
        return;
      }

      this.onChange(value);
      this._financialProduct = { ...this.formFinance.getRawValue() };
      this.onTouched();
    });
  }

  getFinancialPackage() {
    this.isLoading = true;
    this.quoteService.getPackage().subscribe({
      next: (response) => {
        this.financialPackages = response.data ?? [];
        this.isLoading = false;
        if ((this.change == 0 && this.idDeal) || (this.change == 0 && this.quoteService.duplicateDeal)) {
          this.onChangeFinancialProduct();
          this.quoteService.duplicateDeal = null;
          this.change++;
        }
        if (this.financialService?.standardQuoteDeals) {
          const deal: any = this.financialService.standardQuoteDeals?.find?.((i) => i?.id == this.idDeal);
          const term = this.formFinance.controls['term']?.value;
          this.selectedResidual(term);
          this.processNewFinancialProduct();
          if (this.isWarrantyExternal) {
            this.formFinance.controls['externalWarrantyRate'].setValue(deal?.externalWarrantyRate);
          }
        }

      },
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
    });
  }

  processNewFinancialProduct() {
    const financialProductSelected = this.financialProductControl.value;

    const validators: Record<string, any> = {
      DIRECT_CREDIT: {
        required: ['downPaymentTaxType', 'downPaymentTax', 'downPayment'],
        remove: [],
      },
      FINANCIAL_LEASING: {
        required: ['downPaymentTaxType', 'downPaymentTax', 'downPayment'],
        remove: [],
      },
      PURE_LEASING: {
        required: [],
        remove: ['downPaymentTaxType', 'downPaymentTax', 'downPayment']
      },
      /*
      DIRECT_CREDIT_GLOBE: {
        required: ['downPaymentTaxType', 'downPaymentTax', 'downPayment'],
        remove: [],
      }*/
    }
    const requiredFields = validators[financialProductSelected]?.required ?? [];
    const removedFields = validators[financialProductSelected]?.remove ?? [];

    this.removeRequiredValidator(removedFields);
    this.setRequired(requiredFields);
  }

  public checkModelFilter(
    modelTypeSearch?: string,
    personaTypeSearch?: string,
    attributeFinancialSetup?: StandardFinancialSetupAttribute[]
  ): boolean {
    if (!modelTypeSearch) return false;
    if (!personaTypeSearch) return false;
    if (!attributeFinancialSetup) return false;
    const modelType = attributeFinancialSetup
      .filter((i) => i.type == 'PRODUCT_TYPE')
      .map((i) => i.value)
      .join(',');
    const personType = attributeFinancialSetup
      .filter((i) => i.type == 'PERSON_TYPE')
      .map((i) => i.value)
      .join(',');
    if (!modelType || !personType) return false;
    return (
      modelType.includes(modelTypeSearch) &&
      personType.includes(personaTypeSearch)
    );
  }

  //Seleccion de producto financiero
  onChangeFinancialProduct() {
    if (!this.models || !this.financialService || this.models.classification == null) return;

    if (this.isSensitiveFinancialEdit() && this.change !== 0) {
      return;
    }

    this.rebuildFinancialPackageOptions();

    this.packageDescription = '';

    this.processNewFinancialProduct();

    if (this.change === 0) {
      this.onChangePackage();
    } else if (this.formFinance.controls['id'].value) {
      this.setValueNull([
        'id',
        'termId',
        'financialCondition',
        'nominalRate',
        'downPaymentTaxType',
        'downPayment',
        'downPaymentTax',
        'openingFeeType',
        'openingFee',
        'openingFeeTax',
        'calendarType',
        'calculationType',
        'paymentType',
        'balloon',
        'balloonType',
        'balloonPercentage',
      ]);
      this.formFinance.updateValueAndValidity();
      this.deletePaymentsDeal();
    }
  }

  setDaimlerWarranty(deal?: any) {
    if (this.residualValueSelected && this.warrantyType == 'DAIMLER') {
      this.formFinance.controls['daimlerRate'].enable();
      this.formFinance.controls['daimlerRate'].setValue(this.residualValueSelected.daimlerRate);
      this.formFinance.controls['externalWarrantyRate'].disable();
    } else if (this.warrantyType == 'EXTERNAL') {
      this.formFinance.controls['daimlerRate'].setValue(null);
      this.formFinance.controls['daimlerRate'].disable();
      this.formFinance.controls['externalWarrantyRate'].enable();
    }

    if (deal && deal?.externalWarrantyRate) {
      this.warrantyType = warrantyType.external;
      this.residualValues = this.quoteService.models.find((model: any) => model.id == this.quoteService.formData?.model.id)?.residualModelValues ?? [];
      this.residualValueSelected = this.residualValues.find((i) => i.term == deal.standardQuoteCondition.term) ?? null;

      this.formFinance.controls['externalWarrantyRate'].setValidators([
        Validators.required,
        Validators.min(this.residualValueSelected?.externalsMinRate ?? 0),
        Validators.max(this.residualValueSelected?.externalsMaxRate ?? Number.MAX_SAFE_INTEGER)
      ]);

      this.formFinance.controls['externalWarrantyRate'].setValue(deal.externalWarrantyRate);
      this.formFinance.controls['externalWarrantyRate'].updateValueAndValidity();
    }
  }

  //Seleccion de poquete

  onChangePackage() {
    if (!this.idControl.value) return;

    if (this.isSensitiveFinancialEdit() && this.change !== 0) {
      return;
    }

    const financialPackageId = this.idControl.value;
    let selectedPackage = this._financialPackageOptions.find(
      (i) => i.id == financialPackageId
    );

    this.downPaymentTaxType = selectedPackage.downPaymentTaxType;
    if (selectedPackage == null) {
      this.warrantyType = null;
      return;
    }
    this.warrantyType = selectedPackage.warrantyType;


    this.packageDescription = selectedPackage.financialSetupDescription;
    this.packageVersion = selectedPackage.version;
    this.calendarTypeControl.setValue('COMERCIAL');
    this.calculationTypeControl.setValue(selectedPackage.paymentFormationType);
    this.paymentTypeControl.setValue(selectedPackage.paymentType);

    // Establecer taxFree del financial setup
    if (selectedPackage.taxFree !== undefined) {
      this.formFinance.controls['taxFree'].setValue(
        selectedPackage.taxFree === true ||
          selectedPackage.taxFree === 'true' ||
          selectedPackage.taxFree === 'TRUE'
      );
    }

    // Establecer primero el tipo de balloon
    this.balloonTypeControl.setValue(selectedPackage.balloonType);

    // Si es monto fijo, establecer el valor directamente en balloon
    if (selectedPackage.balloonType === this.taxType.fixedAmount) {
      this.balloonControl.setValue(selectedPackage.balloonPercentage);
      // Removemos el validator requerido
      this.balloonControl.clearValidators();
      this.balloonControl.updateValueAndValidity();
    } else {
      // Si no es monto fijo, establecer el porcentaje
      this.balloonPercentageControl.setValue(Number(selectedPackage.balloonPercentage));
    }

    this.downPaymentTaxTypeControl.setValue(selectedPackage.downPaymentTaxType);
    this.openingFeeTypeControl.setValue(selectedPackage.openingFeeType);
    this.paymentTerms = selectedPackage.financialConditions;
    this.paymentTerms.sort((a, b) => parseInt(a.term) - parseInt(b.term));

    if (this.change == 0) {
      this.onChangeTerm();
    } else {
      this.setValueNull([
        'termId',
        'financialCondition',
        'nominalRate',
        'downPayment',
        'downPaymentTax',
        'openingFee',
        'openingFeeTax',
      ]);
      this.formFinance.updateValueAndValidity({ emitEvent: true });
      this.deletePaymentsDeal();
    }

    this.calculateDownPayment();
    this.calculateOpeningFee();
    this.calculateBalloon();

    this.processNewFinancialProduct();
    const term = this.formFinance.controls['term']?.value;
    this.selectedResidual(term);
    this.formFinance.updateValueAndValidity({ emitEvent: true });
  }

  //Seleccion de plazo

  onChangeTerm() {
    const termId = this.termIdControl.value;
    if (!termId) return;

    const isSensitive =
      this.idDeal &&
      (this.grace?.length > 0 ||
        this.specialPayments?.length > 0 ||
        !!this.insurance);

    if (this.residualValues.length == 0) {
      this.residualValues = this.quoteService.models.find((model: any) => model.id == this.quoteService.formData?.model.id)?.residualModelValues ?? [];
    }

    const term = this.paymentTerms.find((i) => i.id == termId);
    if (!isSensitive) {
      this.financialConditionEmit.emit(term);
    }
    this.formFinance.controls['financialCondition'].setValue(term);
    this.nominalRateControl.setValue(term.nominalRate.toFixed(2));
    this.minDownPaymentPercentage = term.minDownPaymentPercentage;
    this.maxDownPaymentPercentage = term.maxDownPaymentPercentage;
    const downPayType = this.downPaymentTaxTypeControl.value;
    if (downPayType === this.taxType.fixedAmount) {
      this.downPaymentTaxControl.setValue(this.minDownPaymentPercentage);
    } else {
      const rawPct = this.downPaymentTaxControl.value;
      const existingPct = Number(rawPct);
      const hasSavedPctWithinTerm =
        rawPct != null &&
        rawPct !== '' &&
        Number.isFinite(existingPct) &&
        existingPct >= term.minDownPaymentPercentage &&
        existingPct <= term.maxDownPaymentPercentage;
      if (!hasSavedPctWithinTerm) {
        this.downPaymentTaxControl.setValue(this.minDownPaymentPercentage);
      }
    }
    this.openingFeeTaxControl.setValue(term.openingFeePercentage);
    this.openingFeeControl.setValue(this.calculateAmount('openingFeeTax'));

    this.residualValueSelected = null;
    this.selectedResidual(term.term);

    const priceModel = this.getPrice();
    if (!priceModel) return;
    this.minDownPaymentPrice =
      priceModel * ((term.minDownPaymentPercentage * 0.01) / 100);
    this.maxDownPaymentPrice =
      priceModel * ((term.maxDownPaymentPercentage * 0.01) / 100);

    if (this.change == 0) {
      this._financialProduct = {
        financialProduct: this.financialProductControl.value,
        id: this.idControl.value,
        termId: this.termIdControl.value,
        downPaymentTax: this.downPaymentTaxControl.value,
        downPayment: this.downPaymentControl.value,
        openingFeeTax: this.openingFeeTaxControl.value,
        openingFee: this.openingFeeControl.value,
        balloon: this.balloonControl.value,
        balloonType: this.balloonTypeControl.value,
        balloonPercentage: this.balloonPercentageControl.value,
      };
    } else {
      if (!isSensitive) {
        this.deletePaymentsDeal();
      }
    }
    this.calculateDownPayment('downPayment', 'percentaje');
    this.calculateOpeningFee('openingFeeTax', 'percentaje');
    this.calculateBalloon('balloonPercentage', 'percentaje');
  }

  selectedResidual(term: any) {
    const financialProduct = this.financialProductControl.value;
    if (financialProduct !== FinancialProductEnum.pureLease || !term) {
      this.setValueAndErrors(['daimlerRate', "externalsMinRate", "externalsMaxRate", "externalWarrantyRate"]);
      return;
    }
    let selected = this.residualValues?.find?.((i) => i?.term == term);
    if (this.residualValues.length <= 0 || !selected) {
      if (this.isWarrantyExternal) {
        this.formFinance.controls['externalsMinRate'].setErrors({ required: true });
      } else {
        this.formFinance.controls['daimlerRate'].setErrors({ required: true });
      }
      return;
    }
    this.residualValueSelected = selected ? selected : null;
    this.formFinance.controls['term'].setValue(selected?.term);
    const daimlerFixedAmount = selected?.daimlerFixedAmount ?? 0;
    const externalsMaxRate = selected?.externalsMaxRate ?? 0;
    const externalsMinRate = selected?.externalsMinRate ?? 0;
    this.setValueAndErrors(['daimlerRate', "externalsMinRate", "externalsMaxRate"]);
    if (this.isWarrantyExternal) {
      // this.formFinance.controls['externalWarrantyRate'].setValue(0);
      this.formFinance.controls['externalsMaxRate'].setValue(externalsMaxRate);
      this.formFinance.controls['externalsMinRate'].setValue(externalsMinRate);
      const minIsZero = externalsMinRate === 0;
      this.formFinance.controls['externalWarrantyRate'].setValidators([
        Validators.required,
        Validators.min(minIsZero ? 1 : externalsMinRate),
        Validators.max(externalsMaxRate)
      ]);
      this.formFinance.controls['externalWarrantyRate'].updateValueAndValidity();
      return;
    }
    this.setValueAndErrors(["externalWarrantyRate"]);
    const daimlerRateControl = this.formFinance.controls['daimlerRate'];
    daimlerRateControl.setValidators([
      Validators.required,
      Validators.min(1),
    ]);
    daimlerRateControl.setValue(daimlerFixedAmount);
    daimlerRateControl.markAsTouched();
    daimlerRateControl.updateValueAndValidity({ emitEvent: true });
  }

  calculateDownPayment(id?: string, type?: string) {
    const downPaymentTaxType = this.downPaymentTaxTypeControl.value;
    let valid = false;
    const usesPriceBoundsForDownPayment =
      downPaymentTaxType === this.taxType.invoiceWithTax ||
      downPaymentTaxType === this.taxType.invoiceWithoutTax ||
      downPaymentTaxType === this.taxType.fixedAmount;
    const priceBoundsNotReadyYet =
      this.minDownPaymentPrice == null || this.maxDownPaymentPrice == null;

    if (!downPaymentTaxType) {
      this.setValueAndErrors(['downPaymentTax', 'downPayment']);
    } else if (usesPriceBoundsForDownPayment && priceBoundsNotReadyYet) {
      // Paquete/plazo puede aplicarse antes que el precio del modelo: no pisar enganche ya hidratado desde la deal.
    } else if (
      (!this.minDownPaymentPrice && this.minDownPaymentPrice != 0) ||
      (!this.maxDownPaymentPrice && this.maxDownPaymentPrice != 0)
    ) {
      this.setValueAndErrors(['downPaymentTax', 'downPayment']);
    }

    if (downPaymentTaxType == this.taxType.fixedAmount) {
      this.formFinance.controls['downPayment'].setValidators(
        Validators.required
      );
      this.setValueAndErrors(['downPaymentTax']);
    } else if (
      downPaymentTaxType == this.taxType.invoiceWithTax ||
      downPaymentTaxType == this.taxType.invoiceWithoutTax
    ) {
      valid = this.percentageValid();
      this.formFinance.controls['downPaymentTax'].setValidators(
        Validators.required
      );
      if (this.change != 0 && !type) {
        this.setValueAndErrors(['downPayment']);
      }
    }

    if (type == 'percentaje' && valid) {
      this.formFinance.controls['downPayment'].setValue(
        this.calculateAmount('downPaymentTax') ?? 0
      );
    } else if (type == 'fixed') {
      this.formFinance.controls['downPaymentTax'].setValue(
        this.calcularPercentaje('downPayment') ?? 0
      );
      this.hideAmountInput(id, true);
    }

    this.formFinance.updateValueAndValidity();
  }

  calculateOpeningFee(id?: string, type?: string) {
    const openingFeeType = this.openingFeeTypeControl.value;

    if (!openingFeeType) {
      this.setValueAndErrors(['openingFeeTax', 'openingFee']);
    }

    if (openingFeeType == this.taxType.fixedAmount) {
      this.setValueAndErrors(['openingFeeTax']);

      this.openingFeeControl.setValidators(Validators.required);
    } else if (openingFeeType == this.taxType.invoiceWithTax) {
      this.setValueAndErrors(['openingFee']);
      this.openingFeeTaxControl.setValidators(Validators.required);
    }

    if (openingFeeType == this.taxType.fixedAmount && id && type == 'fixed') {
      this.hideAmountInput(id, true);
    }

    if (type == 'percentaje') {
      this.openingFeeControl.setValue(this.calculateAmount('openingFeeTax'));
    } else if (type == 'fixed') {
      this.openingFeeTaxControl.setValue(this.calcularPercentaje('openingFee'));
      this.hideAmountInput(id, true);
    }
    this.formFinance.updateValueAndValidity();
  }

  calculateBalloon(id?: string, type?: string) {
    const balloonType = this.balloonTypeControl.value;

    if (!balloonType) {
      this.setValueAndErrors(['balloonPercentage', 'balloon']);
      return;
    }

    if (balloonType == this.taxType.fixedAmount) {
      this.setValueAndErrors(['balloonPercentage']);
      // Removemos el validator requerido
      this.balloonControl.clearValidators();
      this.balloonControl.updateValueAndValidity();

      // Solo calcular si no es monto fijo directo
      if (!type && !this.balloonControl.value) {
        const balloonValue = this.calculateAmount('balloonPercentage');
        this.balloonControl.setValue(balloonValue);
        this.balloonControl.updateValueAndValidity();
      }
    } else if (balloonType == this.taxType.invoiceWithTax) {
      this.setValueAndErrors(['balloon']);
      this.balloonPercentageControl.setValidators(Validators.required);
      this.balloonPercentageControl.updateValueAndValidity();
    }

    if (balloonType == this.taxType.fixedAmount && id && type == 'fixed') {
      this.hideAmountInput(id, true);
    }

    if (type == 'percentaje') {
      const balloonValue = this.calculateAmount('balloonPercentage');
      this.balloonControl.setValue(balloonValue);
      this.balloonControl.updateValueAndValidity();
    } else if (type == 'fixed') {
      const percentageValue = this.calcularPercentaje('balloon');
      this.balloonPercentageControl.setValue(percentageValue);
      this.balloonPercentageControl.updateValueAndValidity();
      this.hideAmountInput(id, true);
    }

    this.formFinance.updateValueAndValidity({ emitEvent: true });
  }

  percentageValid(): boolean {
    const percentaje = this.downPaymentTaxControl.value;

    if (
      !percentaje ||
      (!this.minDownPaymentPercentage && this.minDownPaymentPercentage != 0) ||
      (!this.maxDownPaymentPercentage && this.maxDownPaymentPercentage != 0)
    ) {
      return false;
    } else if (
      percentaje < this.minDownPaymentPercentage ||
      percentaje > this.maxDownPaymentPercentage
    ) {
      this.downPaymentTaxControl.setValue(null);
      this.downPaymentControl.setValue(null);
      return false;
    }
    return true;
  }

  amountValid() {
    const amount = this.downPaymentControl.value;
    if (!amount || !this.minDownPaymentPrice || !this.maxDownPaymentPrice)
      return;
    if (
      amount < this.minDownPaymentPrice ||
      amount > this.maxDownPaymentPrice
    ) {
      this.downPaymentControl.setValue(null);
      this.downPaymentTaxControl.setValue(null);
    }
  }

  setRequired(fields: string[]) {
    fields.map((field) => {
      this.formFinance.controls[field].setValidators(Validators.required);
    });
  }

  removeRequiredValidator(fields: string[]) {
    fields.map((field) => {
      this.formFinance.controls[field].removeValidators(Validators.required);
    });
  }

  setValueNull(fields: string[]) {
    fields.map((field) => {
      this.formFinance.controls[field].setValue(null);
    });
  }

  setValueAndErrors(fields: string[]) {
    fields.map((field) => {
      this.formFinance.controls[field].setValue(null);
      this.formFinance.controls[field].setErrors(null);
      this.formFinance.controls[field].clearValidators();
    });
  }

  private isSensitiveFinancialEdit(): boolean {
    return !!(
      this.idDeal &&
      (this.grace?.length > 0 ||
        this.specialPayments?.length > 0 ||
        !!this.insurance)
    );
  }

  private shouldOpenSensitiveModalForTermChangeBecauseOfInsurance(): boolean {
    const graceLen = this.grace?.length ?? 0;
    const spLen = this.specialPayments?.length ?? 0;
    if (graceLen > 0 || spLen > 0) {
      return true;
    }
    if (!this.insurance) {
      return true;
    }
    const type = this.insurance?.insuranceType as string | undefined;
    if (!type) {
      return true;
    }
    if (
      type === InsuranceTypeEnum.COUNTED_MULTIYEAR ||
      type === InsuranceTypeEnum.FINANCED_MULTIYEAR
    ) {
      return true;
    }
    if (
      type === InsuranceTypeEnum.COUNTED_ANNUAL ||
      type === InsuranceTypeEnum.FINANCED_ANNUAL
    ) {
      const termId = this.termIdControl.value;
      const row = this.paymentTerms?.find((i) => i.id == termId);
      const months =
        row?.term != null ? parseInt(String(row.term), 10) : NaN;
      if (Number.isNaN(months)) {
        return true;
      }
      return months < 12;
    }
    return true;
  }

  private rebuildFinancialPackageOptions(): void {
    if (
      !this.financialService ||
      !this.models ||
      this.models.classification == null
    ) {
      this._financialPackageOptions = [];
      return;
    }
    const financialProductSelected = this.financialProductControl.value;
    const companyName = this.financialService.companyName;
    const modelId = this.quoteService.formData?.model.id;
    const modelType = this.quoteService.formData?.model.modelType;
    const dealerId = this.quoteService.formData?.wholeSaleId;
    const personType = this.quoteService.formData?.customer?.personType;

    this._financialPackageOptions = this.financialPackages.filter((i) => {
      const dealerTypeAttributes = Array.isArray(
        i.standardFinancialSetupAttributes
      )
        ? i.standardFinancialSetupAttributes.filter(
            (attr) => attr.type === 'DEALER_TYPE'
          )
        : [];
      const hasDealerFull = dealerTypeAttributes.some(
        (attr) => attr.value === 'DEALER_FULL'
      );
      const hasDealerPartial = dealerTypeAttributes.some(
        (attr) => attr.value === 'DEALER_PARTIAL'
      );
      const isDealerValid = hasDealerFull
        ? true
        : hasDealerPartial
          ? Array.isArray(i.dealerIds) &&
            dealerId &&
            i.dealerIds.includes(dealerId)
          : false;

      let isModelValid = false;
      const productTypeAttributes = Array.isArray(
        i.standardFinancialSetupAttributes
      )
        ? i.standardFinancialSetupAttributes.filter(
            (attr) => attr.type === 'PRODUCT_TYPE' && attr.value === modelType
          )
        : [];

      if (productTypeAttributes.length > 0) {
        const productTypeAttribute = productTypeAttributes[0];

        if (!productTypeAttribute.partial) {
          isModelValid = true;
        } else {
          const matchingModel = i.financialSetupModels?.some(
            (model: any) => model.id === modelId
          );
          isModelValid = !!matchingModel;
        }
      }

      if (
        environment.featureLoyaltyFeriaQuotation &&
        !this.packageVisibleForCustomerPrograms(i)
      ) {
        return false;
      }

      const isValid =
        i.financialProduct === financialProductSelected &&
        i.classification === this.models?.classification &&
        packageAppliesToQuoteCompany(i.companyName, companyName) &&
        this.checkModelFilter(
          this.models?.modelType,
          personType,
          i.standardFinancialSetupAttributes
        ) &&
        isDealerValid &&
        isModelValid;

      return isValid;
    });
  }

  private packageVisibleForCustomerPrograms(
    pkg: financialResponseDto
  ): boolean {
    const c = this.quoteService.formData?.customer as
      | { feriaCustomer?: boolean }
      | undefined;
    if (Boolean(c?.feriaCustomer)) {
      const pkgLoyalty =
        pkg.loyaltyFinancialPackage === true ||
        (pkg.loyaltyFinancialPackage as any) === 'true';
      return !pkgLoyalty;
    }
    return true;
  }

  private onCustomerLoyaltyFeriaFlagsChanged(): void {
    if (!environment.featureLoyaltyFeriaQuotation) {
      return;
    }
    const prevId = this.formFinance?.controls['id']?.value;
    this.rebuildFinancialPackageOptions();
    const stillOk =
      !!prevId &&
      this._financialPackageOptions.some(
        (p: financialResponseDto) => p.id == prevId
      );
    if (prevId && !stillOk) {
      this.setValueNull([
        'id',
        'termId',
        'financialCondition',
        'nominalRate',
        'downPaymentTaxType',
        'downPayment',
        'downPaymentTax',
        'openingFeeType',
        'openingFee',
        'openingFeeTax',
        'calendarType',
        'calculationType',
        'paymentType',
        'balloon',
        'balloonType',
        'balloonPercentage',
      ]);
      this.formFinance.updateValueAndValidity();
      this.packageDescription = '';
      this.paymentTerms = [];
      this.deletePaymentsDeal(true);
      this.onChange(this.formFinance.getRawValue());
      this.processNewFinancialProduct();
    }
  }

  private syncPackageListsAndLabelsFromForm(): void {
    this.rebuildFinancialPackageOptions();
    const pkgId = this.idControl.value;
    if (!pkgId) {
      this.paymentTerms = [];
      return;
    }
    const selectedPackage = this._financialPackageOptions.find(
      (i) => i.id == pkgId
    );
    if (!selectedPackage) {
      this.paymentTerms = [];
      return;
    }
    this.downPaymentTaxType = selectedPackage.downPaymentTaxType;
    this.warrantyType = selectedPackage.warrantyType;
    this.packageDescription = selectedPackage.financialSetupDescription;
    this.packageVersion = selectedPackage.version;
    this.paymentTerms = [...(selectedPackage.financialConditions ?? [])].sort(
      (a, b) => parseInt(a.term, 10) - parseInt(b.term, 10)
    );
  }

  private refreshAuxiliaryFinancialStateAfterRevert(): void {
    if (this.financialPackages?.length) {
      this.syncPackageListsAndLabelsFromForm();
    }
    this.syncDownPaymentBoundsToCurrentTerm();
    this.processNewFinancialProduct();
    const term = this.formFinance.controls['term']?.value;
    this.selectedResidual(term);
  }

  private syncDownPaymentBoundsToCurrentTerm(): void {
    const termId = this.termIdControl.value;
    if (!termId || !this.paymentTerms?.length) return;
    const term = this.paymentTerms.find((i) => i.id == termId);
    if (!term) return;
    this.minDownPaymentPercentage = term.minDownPaymentPercentage;
    this.maxDownPaymentPercentage = term.maxDownPaymentPercentage;
    const priceModel = this.getPrice();
    if (!priceModel) return;
    this.minDownPaymentPrice =
      priceModel * ((term.minDownPaymentPercentage * 0.01) / 100);
    this.maxDownPaymentPrice =
      priceModel * ((term.maxDownPaymentPercentage * 0.01) / 100);
  }

  private runWithoutFinancialFormValueChanges(fn: () => void): void {
    this._suppressFinancialFormValueChanges = true;
    try {
      fn();
    } finally {
      this._suppressFinancialFormValueChanges = false;
    }
  }

  private markSensitiveFinanceControlsPristine(): void {
    for (const name of this._sensitiveFinanceFieldNames) {
      this.formFinance.get(name)?.markAsPristine();
    }
  }

  cancelChanges() {
    this._pendingFinancialValue = null;
    this.formFinance.patchValue(this._financialProduct, { emitEvent: false });
    this.markSensitiveFinanceControlsPristine();
    this.runWithoutFinancialFormValueChanges(() =>
      this.refreshAuxiliaryFinancialStateAfterRevert()
    );
    this.onChange(this.formFinance.getRawValue());
    this.modalService.closeModal();
  }

  resetAndDeleteInsurance() {
    if (this._pendingFinancialValue) {
      this.formFinance.patchValue(this._pendingFinancialValue, {
        emitEvent: true,
      });
      this._financialProduct = { ...this.formFinance.getRawValue() };
      this._pendingFinancialValue = null;
      this.runWithoutFinancialFormValueChanges(() =>
        this.refreshAuxiliaryFinancialStateAfterRevert()
      );
    }
    this.deletePaymentsDeal(true);
    this.deleteAllPayments();
  }

  deleteAllPayments() {
    this.modalService.closeModal();
    this._deleteAllPayments.emit();
  }

  showSubsidyInfo(): boolean {
    const pkgId = this.idControl?.value;
    return !!pkgId && this._financialPackageOptions.length > 0;
  }

  isSubsidyNotApplicable(): boolean {
    const pkgId = this.idControl?.value;
    if (!pkgId) {
      return true;
    }
    const pkg = this._financialPackageOptions.find((i) => i.id == pkgId);
    return !pkg?.subsidyType || pkg.subsidyType === TaxType.NOT_TAXED;
  }


  private subsidyPercentLeadingLabel(subsidyType: TaxType, subsidyValue: number): string {
    const p = subsidyValue.toFixed(2);
    switch (subsidyType) {
      case TaxType.invoiceWithTax:
        return `${p} % (con IVA)`;
      case TaxType.invoiceWithoutTax:
        return `${p} % (sin IVA)`;
      case TaxType.amountToFinance:
        return `${p} % (sobre monto a financiar)`;
      default:
        return `${p} %`;
    }
  }

  private parseNumeric(input: unknown): number {
    if (typeof input === 'number') {
      return input;
    }
    if (typeof input === 'string') {
      // Accept "900,000.00" style strings.
      const normalized = input.replace(/,/g, '').trim();
      const n = Number(normalized);
      return Number.isFinite(n) ? n : NaN;
    }
    if (input == null) {
      return NaN;
    }
    const n = Number(input as any);
    return Number.isFinite(n) ? n : NaN;
  }


  getSubsidyPreview(): { amount: number; percentLeadingLabel: string } | null {
    const pkgId = this.idControl?.value;
    if (!pkgId || !this.formFinance) {
      return null;
    }
    const pkg = this._financialPackageOptions.find((i) => i.id == pkgId);
    if (!pkg?.subsidyType || pkg.subsidyType === TaxType.NOT_TAXED) {
      return null;
    }
    const sv =
      pkg.subsidyValue != null ? Number(pkg.subsidyValue) : NaN;
    if (Number.isNaN(sv)) {
      return null;
    }

    const tax = 16;

    // Mismo criterio que Open Quote: bases y `calculateSubsidyAmount` son **por unidad**; la UI muestra subsidio por unidad.
    const unitPriceWithTax = this.getPrice() || 0;
    const unitPriceWithoutTax =
      unitPriceWithTax > 0 ? unitPriceWithTax / (1 + tax / 100) : 0;

    const downPaymentRaw = this.parseNumeric(this.formFinance.controls['downPayment']?.value);
    const downPaymentUnit = Number.isFinite(downPaymentRaw) ? downPaymentRaw : 0;

    const fp = this.financialProductControl?.value as FinancialProductEnum;
    const taxDecimal = tax / 100;
    let financialAmountUnit = 0;
    if (fp === FinancialProductEnum.pureLease) {
      financialAmountUnit = unitPriceWithoutTax;
    } else if (fp === FinancialProductEnum.financialLeasing) {
      financialAmountUnit = (unitPriceWithTax - downPaymentUnit) / (1 + taxDecimal);
    } else {
      // Direct credit, cap loan, real estate, etc.
      financialAmountUnit = unitPriceWithTax - downPaymentUnit;
    }
    financialAmountUnit = Math.max(0, financialAmountUnit);

    const st = pkg.subsidyType as TaxType;

    if (st === TaxType.fixedAmount) {
      const amount = sv;
      const pct =
        unitPriceWithoutTax > 0 ? (amount / unitPriceWithoutTax) * 100 : 0;
      return {
        amount,
        percentLeadingLabel: `${pct.toFixed(2)} % (sin IVA)`,
      };
    }

    const unitAmountStr = this.financialCalculator.calculateSubsidyAmount(
      st,
      sv,
      0,
      tax,
      unitPriceWithTax,
      unitPriceWithoutTax,
      financialAmountUnit
    );
    const unitAmount = Number(unitAmountStr);
    const amount = Number.isFinite(unitAmount) ? unitAmount : 0;
    return {
      amount,
      percentLeadingLabel: this.subsidyPercentLeadingLabel(st, sv),
    };
  }

  calculateAmount(typeField: string) {
    const percentaje = this.formFinance.controls[typeField].value;
    const priceModel = this.getPrice();
    let decimalPercentaje: number;

    if (this.downPaymentTaxType === this.taxType.invoiceWithTax) {
      decimalPercentaje = percentaje / 100;
    } else {
      decimalPercentaje = percentaje / 116;
    }

    if (!priceModel || !percentaje) return;
    const amount = priceModel * decimalPercentaje;
    return amount.toFixed(2);
  }

  calcularPercentaje(typeField: string) {
    const amountFixed = this.formFinance.controls[typeField].value;
    const priceModel = this.getPrice();
    let percentaje: number | null;

    if (!priceModel || !amountFixed) return;

    if (this.downPaymentTaxType === this.taxType.invoiceWithTax) {
      percentaje = (amountFixed / priceModel) * 100;

    } else {
      percentaje = (amountFixed / priceModel) * 116;

    }

    if (
      (typeField == 'downPayment' &&
        percentaje < this.minDownPaymentPercentage) ||
      percentaje > this.maxDownPaymentPercentage
    ) {
      percentaje = null;
      this.downPaymentControl.setValue(null);
    }
    return percentaje?.toFixed(2);
  }

  //#region CVA
  writeValue(value: any): void {
    if (!value) return;
    const patch: Record<string, any> = { ...value };
    /** Evita que un segundo writeValue parcial (p. ej. tras 401 en catálogos) pise enganche/comisión con null. */
    const preserveIfIncomingNull = [
      'downPaymentTax',
      'downPayment',
      'openingFee',
      'openingFeeTax',
    ] as const;
    for (const key of preserveIfIncomingNull) {
      if (patch[key] == null && this.formFinance.get(key)?.value != null) {
        delete patch[key];
      }
    }
    this.formFinance.patchValue(patch, { emitEvent: false });
    this._financialProduct = { ...this.formFinance.getRawValue() };
    if (this.financialPackages?.length) {
      this.syncPackageListsAndLabelsFromForm();
    }
    this.syncDownPaymentBoundsToCurrentTerm();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange = (_: any) => { };
  private onTouched = () => { };

  //#endregion

  //#region Validator
  validate(_control: AbstractControl<any, any>): ValidationErrors | null {
    return this.formFinance.valid ? null : { invalidFormFinance: true };
  }

  //#endregion

  emitFormDataForDownload() {
    this.requestDownloadJson.emit(this.formFinance.value);
  }

  showDownPayment() {
    return [
      FinancialProductEnum.directCredit,
      //FinancialProductEnum.directCreditGlobe,
      FinancialProductEnum.financialLeasing
    ].includes(this.financialProductControl.value);
  }

  deletePaymentsDeal(forceEmit = false) {
    if (
      !forceEmit &&
      this.idDeal &&
      (this.grace?.length > 0 ||
        this.specialPayments?.length > 0 ||
        !!this.insurance)
    ) {
      return;
    }
    this.deletePayments.emit(this.payments());
  }

  //#region CONTROLS

  get isWarrantyExternal() {
    return this.warrantyType == 'EXTERNAL';
  }

  get showResidualValueThirdParty() {
    return !!this.termIdControl.value && this.isWarrantyExternal
  }

  get downPaymentControl(): AbstractControl {
    return this.formFinance.controls['downPayment'];
  }

  get downPaymentTaxControl(): AbstractControl {
    return this.formFinance.controls['downPaymentTax'];
  }

  get downPaymentTaxTypeControl(): AbstractControl {
    return this.formFinance.controls['downPaymentTaxType'];
  }

  get financialProductControl(): AbstractControl {
    return this.formFinance.controls['financialProduct'];
  }

  get openingFeeControl(): AbstractControl {
    return this.formFinance.controls['openingFee'];
  }

  get openingFeeTypeControl(): AbstractControl {
    return this.formFinance.controls['openingFeeType'];
  }

  get openingFeeTaxControl(): AbstractControl {
    return this.formFinance.controls['openingFeeTax'];
  }

  get balloonControl(): AbstractControl {
    return this.formFinance.controls['balloon'];
  }

  get balloonTypeControl(): AbstractControl {
    return this.formFinance.controls['balloonType'];
  }

  get balloonPercentageControl(): AbstractControl {
    return this.formFinance.controls['balloonPercentage'];
  }

  get termIdControl(): AbstractControl {
    return this.formFinance.controls['termId'];
  }

  get nominalRateControl(): AbstractControl {
    return this.formFinance.controls['nominalRate'];
  }

  get idControl(): AbstractControl {
    return this.formFinance.controls['id'];
  }

  get calendarTypeControl(): AbstractControl {
    return this.formFinance.controls['calendarType'];
  }

  get calculationTypeControl(): AbstractControl {
    return this.formFinance.controls['calculationType'];
  }

  get paymentTypeControl(): AbstractControl {
    return this.formFinance.controls['paymentType'];
  }

  get formExternalMinRate() {
    return this.formFinance.controls['externalsMinRate']?.value;
  }

  get formExternalMaxRate() {
    return this.formFinance.controls['externalsMaxRate']?.value;
  }

  get externalRatesMorethanZero() {
    return this.formExternalMinRate >= 0 && this.formExternalMaxRate > 0;
  }

  get hasRequiredErrorInDaimlerRate() {
    return this.formFinance.controls['daimlerRate'].getError('required') || this.formFinance.controls['daimlerRate'].getError('min');
  }

  get hasRequiredErrorInExternalWarrantyRate() {
    return this.formFinance.controls['externalWarrantyRate'].getError('required') || this.formFinance.controls['externalWarrantyRate'].getError('min');
  }

  get hasExternalWarrantyRateTouched() {
    return this.formFinance.controls['externalWarrantyRate'].touched;
  }

  get hasTermSelected() {
    return !!this.termIdControl?.value;
  }

  get showExternalWarrantyRateErrors() {
    const validations = this.isWarrantyExternal && this.hasExternalWarrantyRateTouched && this.hasRequiredErrorInExternalWarrantyRate && !this.externalRatesMorethanZero;
    return this.hasTermSelected && validations;
  }

  get showDaimlerRateErrors() {
    return this.hasTermSelected && !this.isWarrantyExternal && this.hasRequiredErrorInDaimlerRate;
  }

  get hasExemptTax() {
    return this.formFinance.controls['financialProduct'].value === FinancialProductEnum.directCredit && this.quoteService.formData?.companyName === 'SOFOM';
  }

  //#endregion
}
